





















































import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { UserTarget } from '@/api/model/user-target'
import { UserTargetAPI } from '@/api/backend-client'
import ListTargetsActions from '@/views/Company/Settings/Users/Edit/ListTargetsActions.vue'

@Component({
    components: {ListTargetsActions},
})
export default class ListTargets extends Vue {
    @Prop({ required: true }) readonly user: User|null
    loading: boolean = false
    targets: UserTarget[] = []

    created() {
        this.onUserChange()
    }

    @Watch('user')
    async onUserChange(): Promise<void> {
        await this.reloadTargets()
    }

    goToTargetsCreate(): void {
        this.$emit('create')
    }

    goToTargetEdit(target: UserTarget): void {
        this.$emit('edit', target)
    }

    async deleteTarget(target: UserTarget): Promise<void> {
        if (confirm(this.$t('company_settings.targets.delete_confirm').toString())) {
            await UserTargetAPI.delete(target.id)
            await this.reloadTargets()
        }
    }

    async reloadTargets(): Promise<void> {
        this.targets = []

        if (this.user) {
            this.loading = true
            this.targets = await UserTargetAPI.getAll()
            this.loading = false
        }
    }

    get filteredTargets(): UserTarget[] {
        return this.targets
            .filter(target => target.user.id === this.user.id)
    }
}
